import { validator } from '@front/common/src/forms/validations';
import { isValidDate } from '@front/common/src/forms/validators/date';

export const dateValidator = (inputName: string) =>
  validator<string | undefined>(inputName, 'valid_date', isValidDate);
